import { of, take, mergeMap } from 'rxjs';
import { SettingsConst } from '@/app/shared/consts/settings.const';

import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { AuthService } from '@/app/core/services/auth/auth.service';

export const AuthInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);

  return of(authService.user).pipe(
    take(1),
    mergeMap(() => {
      const token = localStorage.getItem(SettingsConst['authTokenKey']);

      if (token) {
        const modifiedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next(modifiedRequest);
      }

      return next(request);
    }),
  );
};
